import DynamicIcon from './dynamic-icon';
import Spinner from './spinner';

const Toolbar = ({ children, icon, size, cancel, onClick, color, onCancel, additionalclasses, isLoading }) => {
    return (
        <div onClick={onClick} className={`h-[34px] px-[16px] rounded-[8px] custom-bg-grey-50 grid grid-flow-col items-center justify-items-center gap-[4px] ${onClick ? 'cursor-pointer' : ''} ${additionalclasses}`}>
            {isLoading ?
                (<Spinner size={size} />) : (
                    icon &&<DynamicIcon name={icon} size={size} color={color} />
                )
            }
            {children && <span className='poppins-regular custom-text-grey-800 text-[14px] leading-[21px]'>{children}</span>}
            {cancel && <DynamicIcon onClick={onCancel} name='x' size='16' color={`${color} cursor-pointer`} />}
        </div>
    );
};

export default Toolbar;